import { useEffect, useState } from 'react';
import { weatherGreetingApi } from '../../lib/api';

export const WeatherGreetingSubheading = () => {
  const [text, setText] = useState<string | null>(null);

  useEffect(() => {
    const load = async (): Promise<void> => {
      try {
        const response = await weatherGreetingApi.current();
        if (!response.success || !response.data?.visible || !response.data.text) {
          return;
        }
        setText(response.data.text);
      } catch {
        // Silent failure — sub-heading is optional
      }
    };
    void load();
  }, []);

  if (!text) {
    return null;
  }

  return (
    <p
      className="mt-1 text-sm leading-snug text-gray-600 dark:text-gray-400"
      aria-live="polite"
    >
      {text}
    </p>
  );
};
